/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import { empaqueInitialValues } from "../constants/Empaque.Constants";
import { empaqueValidation } from "../constants/validations";
import { PedidoForm } from "./Pedido.Form";
import { useEffect, useState } from "react";
// import { useSize } from "../../../hooks/useSize";
import { useEmpaque } from "../hooks/useEmpaque";
import Swal from "sweetalert2";

export const EditarPedido = ({
  id_pedido,
  isVisible,
  onClose,
  id_cultivo,
  reload,
}) => {
  const { retrivePedido, editPedido } = useEmpaque();
  const [tamanios, setTamanios] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      await editPedido(id_pedido, values);
      Swal.fire({
        icon: "success",
        title: "Registro actualizado",
        timer: 1500,
      });
      reload();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salió mal",
        text: "Favor de comunicarlo al equipo de desarrollo",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    validateForm,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    onSubmit,
    initialValues: empaqueInitialValues,
    validationSchema: empaqueValidation,
  });

  const validateData = async () => {
    const validation = await validateForm();
    console.log(validation);
    handleSubmit();
  };

  const handleCloseModal = () => {
    resetForm();
    onClose();
  };

  // useEffect(() => {
  //   const getTamanio = async () => {
  //     const response = await getSize(idCultivo);
  //     setSize(response);
  //   };
  //   if (idCultivo !== 0) {
  //     getTamanio();
  //   }
  // }, [idCultivo]);

  useEffect(() => {
    const getPedido = async () => {
      try {
        const response = await retrivePedido(id_pedido);
        console.log(response);
        setValues({
          ...values,
          ...response,
          total: response.tamanios[0].total,
        });
        setTamanios(response.tamanios);
      } catch (error) {
        console.log(error);
      }
    };
    if (id_pedido && id_pedido !== 0) {
      getPedido();
    }
  }, [id_pedido]);

  return (
    <PedidoForm
      values={values}
      tamaniosOptions={tamanios}
      variedadOptions={[]}
      id_cultivo={id_cultivo}
      errors={errors}
      touched={touched}
      handleSubmit={validateData}
      setFieldValue={setFieldValue}
      isVisible={isVisible}
      onClose={handleCloseModal}
      handleChange={handleChange}
      isEditing={true}
      isLoading={isLoading}
    />
  );
};
